module.exports = __webpack_public_path__ + "static/media/icon.0632e152.png";